import { render } from "./TheFooter.vue?vue&type=template&id=0084c12f&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=0084c12f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0084c12f"]])

export default __exports__